import { ProductsApiRemoteService } from '../../Services/api/products/products-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyProductUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly ProductsApi: ProductsApiRemoteService) {}
    

  public async handle (
    data: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

        const response = await this.ProductsApi.destroy(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
